import { createRouter, createWebHistory, RouteRecordRaw } from "vue-router";
import AppLoginPage from "../views/login-page/login.page.vue";
import AppSignupPage from "../views/signup-page/signup.page.vue";
import AppForgotPage from "../views/forgot-page/forgot.page.vue";
import AppResetPage from "../views/reset-page/reset.page.vue";
import AppVerifyEmailPage from "../views/verify-email-page/verify-email.page.vue";
import { OutGuardGenerate, OUT_NAV_NAMES } from "@/shared/guards/out.guards";
import AuthRouterApp from "../views/Router.App.vue";

/**
 *
 */
const routes: Array<RouteRecordRaw> = [
  {
    path: "",
    beforeEnter: OutGuardGenerate(),
    component: AuthRouterApp,
    children: [
      {
        path: "",
        redirect: "/login",
      },
      {
        path: "login",
        component: AppLoginPage,
      },
      {
        path: "signup/founder",
        component: AppSignupPage,
      },
      {
        path: "signup/talent",
        component: AppSignupPage,
      },
      {
        path: "reset",
        component: AppResetPage,
        name: OUT_NAV_NAMES.RESET,
      },
      {
        path: "forgot",
        component: AppForgotPage,
      },
      {
        path: "verify",
        component: AppVerifyEmailPage,
        name: OUT_NAV_NAMES.VERIFY,
      },
    ],
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

export default router;
